import { lazy } from 'react';

const CreateAccountModal = lazy(() => import('./CreateAccountModal'));
const SignUpAsGuestModal = lazy(() => import('./SignUpAsGuestModal'));

export default {
  CREATE_ACCOUNT_MODAL: CreateAccountModal,
  SIGN_UP_AS_GUEST_MODAL: SignUpAsGuestModal,
};
